<template>
	<div class="info_Details" v-if="Object.keys(getinfo).length > 0">
		<el-dialog title="订单详情" width="800px" :visible.sync="dialogTableVisible" :lock-scroll="false">
			<div class="show_number w3">
				{{ getinfo.BetContent }}
			</div>
			<div class="bet_detail">
				<div class="pet_detail_left">
					<div class="detail_item">
						订单编号：<b>{{ getinfo.OrderNumber }}</b>
					</div>
					<div class="detail_item">彩种名称：{{ getinfo.LgName }}</div>
					<div class="detail_item">
						玩法名称：{{ getinfo.LpName }}
						<span v-if="getinfo.RxDsFormart != null">({{ getinfo.RxDsFormart }})</span>
					</div>
					<div class="detail_item">
						投注期号：<b>{{ getinfo.Lssue }}</b>
					</div>
					<div class="detail_item">
						投注时间：<b>{{ getinfo.BetTime }}</b>
					</div>
					<div class="detail_item">
						完成时间：<b>{{ getinfo.CompleteTime }}</b>
					</div>
					<div class="detail_item">奖金模式：{{ getinfo.AmName }}</div>
					<div class="detail_item">
						订单状态：
						<span v-if="getinfo.Status == 1" style="color: #8b8b8b">{{ getinfo.StatusText }}</span>
						<span v-if="getinfo.Status == 2" style="color: #b0b0b0">{{ getinfo.StatusText }}</span>
						<span v-if="getinfo.Status == 3" style="color: #d86556">{{ getinfo.StatusText }}</span>
						<span v-if="getinfo.Status == 4" style="color: #008573">{{ getinfo.StatusText }}</span>
					</div>
					<div class="detail_item">开奖号码：{{ getinfo.OpenNumber }}</div>
				</div>
				<div class="pet_detail_right">
					<div class="detail_item">
						投注注数：<b>{{ getinfo.BetCount }}</b>
					</div>
					<div class="detail_item">
						投注倍数：<b>{{ getinfo.BetMultiple }}</b
						>倍
					</div>
					<div class="detail_item">
						投注金额：<b>{{ getinfo.BetMoney.toFixed(3) }}</b
						>元
					</div>
					<div class="detail_item">
						奖金返点：<b>{{ getinfo.BetBonus.toFixed(3) }}</b
						>元 | <b>{{ getinfo.BetRebate.toFixed(1) }}</b
						>%
					</div>
					<div class="detail_item">
						中奖金额：<b>{{ getinfo.WinBonus.toFixed(3) }}</b
						>元
					</div>
					<div class="detail_item">
						中奖注数：<b>{{ getinfo.WinCount }}</b
						>注
					</div>
					<div class="detail_item" v-if="getinfo.Status == 4 || getinfo.Status == 3">
						盈亏金额：￥ <b>{{ getinfo.KuiYing.toFixed(3) }}</b
						>元
					</div>
					<div class="detail_item" v-else>盈亏金额：￥<b>0.000</b>元</div>
					<div class="cancellations_item">
						订单操作：
						<el-button class="cancellations" size="mini" type="primary" v-if="getinfo.Status == 1" @click="cancel"
							>撤单</el-button
						>
					</div>
				</div>
			</div>
		</el-dialog>
		<el-button :plain="true" @click="openSucc"></el-button>
		<el-button :plain="true" @click="openFail"></el-button>
		<OrderCancel ref="orderCancel" :confirm="cancelOrderConfirm">
			<template slot="content">
				<span>您将撤销</span>
				<span>{{ cancelOrderTips }}</span>
				<span>订单</span>
			</template>
		</OrderCancel>
	</div>
</template>
<script>
import { postAjax, getAjax } from "../../util/ajax.js";
import OrderCancel from "@/components/Elasticframe/OrderCancel";

export default {
	components: { OrderCancel },
	props: {
		getinfo: {
			type: Object,
			require: true,
		},
	},
	data() {
		return {
			cancelOrderTips: "",
			dialogTableVisible: false, //表格状态
			detailData: this.getinfo,
		};
	},
	methods: {
		cancelOrderConfirm() {
			let that = this;
			let url = "api/Bet/CancleOrder?number=" + this.getinfo.OrderNumber + "&type=1";
			postAjax(url).then(function (data) {
				if (data.Data == false) {
					that.openFail();
				} else if (data.Data == true) {
					that.openSucc();
				}
				that.$emit("list");
				that.$emit("getinfo");
				that.dialogTableVisible = false;
			});
		},
		// 撤销订单
		cancel() {
			this.cancelOrderTips = `${this.getinfo.LgName} ${this.getinfo.Lssue}期`;
			this.$refs.orderCancel.show();
		},
		openSucc() {
			this.$message({ message: "已成功取消订单", type: "success" });
		},
		openFail() {
			this.$message.error("取消订单失败");
		},
		closeThisDiv() {
			this.dialogTableVisible = false;
		},
	},
	created() {},
};
</script>
<style>
.info_Details .el-dialog {
	background-color: #ffffff;
}

.close_but {
	position: absolute;
	right: 0;
	top: 0;
	width: 40px;
	height: 42px;
	line-height: 42px;
	text-align: center;
	cursor: pointer;
	color: #ffffff;
}

.info_Details .el-icon-close {
	display: none;
}

.info_Details .show_number {
	border: 1px solid #d7d7d7;
	height: 63px;
	padding: 10px 14px;
	color: #1d1d1d;
	overflow-y: auto;
}

.info_Details .bet_detail {
	padding-top: 24px;
	display: flex;
}

.info_Details .pet_detail_left,
.info_Details .pet_detail_right {
	width: 50%;
}

.info_Details .detail_item {
	line-height: 14px;
	margin-top: 16px;
}

.info_Details .cancellations_item {
	display: flex;
	align-items: center;
	margin-top: 8px;
}

.info_Details > .el-button {
	display: none;
}

.info_Details .detail_item > span {
	color: red;
}

.info_Details .detail_item > b {
	font-family: "HiraginoSansGB-W3";
	font-weight: 400;
}

.info_Details ::-webkit-scrollbar {
	display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Elasticframe/infodetails.vue